// ============================================
// APPLICATION CONSTANTS
// ============================================

// App General
export const appName = "GDS.ai Axon";
export const APP_SUBTITLE = "Powered by - GDS Assurance Digital";
export const AI_ASSISTANT_NAME = "Axon AI";
export const WELCOME_TITLE = "GDS.ai Axon";
export const getWelcomeMessage = (userName, roleName) =>
  `Hi ${userName || "there"}!\nI'm your ${roleName || "Axon"} buddy. How can I help you?`;
export const WELCOME_MESSAGE = getWelcomeMessage("there");

// Session Timeout
export const sessionTimeoutTitle = "Your session is about to expire";
export const sessionTimeoutMessage =
  "You're being timed out due to inactivity. Please choose to stay signed in or signed out. Otherwise, you will be signed out automatically in $1 minute(s).";
export const sessionTimeoutStayLoggedIn = "Stay signed in";
export const sessionTimeoutLogOut = "Sign out now";

// ============================================
// HEADER CONSTANTS
// ============================================
export const HEADER = {
  LOG_OUT: "Log out",
  NOTIFICATIONS: "Notifications",
  LOGO_ALT: "LOGO",
  USER_NAME_FALLBACK: "User Name",
  DESIGNATION_FALLBACK: "Designation",
  USER_ROLES: ["DID", "Regional Manager"],
  CONTACT_SUPPORT_URL: " https://eyct.service-now.com/",
  FUNCTIONAL_GUIDANCE_URL:
    "https://sites.ey.com/sites/GDSEastInnovation/Shared%20Documents/Forms/AllItems.aspx?csf=1&web=1&e=ocyFSM&CID=eee5d045-6188-42dc-9800-098d97e36482&FolderCTID=0x0120002FFDA864AACFA045A31EE37A4B25D21E&id=%2fsites%2fGDSEastInnovation%2fShared%20Documents%2fAxon%2fFunctional%20Guide",
};

// ============================================
// SIDE MENU CONSTANTS
// ============================================
export const SIDE_MENU = {
  HOME: "Home",
  MY_ORDERS: "My Orders",
  MY_TASKS: "My Tasks",
  ALL_ORDERS: "All Orders",
  REPORTS: "Reports",
  USER_MANAGEMENT: "User Management",
  QUALITY_FRAMEWORK: "Quality Framework",
  LAAP: "Manage Leave",
};

// ============================================
// USER MANAGEMENT CONSTANTS
// ============================================
export const USER_MANAGEMENT = {
  TITLE: "User Management",
  SEARCH_PLACEHOLDER: "Search",
  ADD_USER: "Add User",
  EDIT: "Edit",
  SHOW: "Show",
  COLUMNS: {
    S_NO: "S. No.",
    EMAIL: "Email",
    AREA: "Area",
    REGION_COUNTRY: "Region/Country",
    SUPER_REGION: "Super Region",
    ROLE: "Role",
    STATUS: "Status",
    ACTION: "Action",
  },
  TOOTLTIP: "Invalid email address. Please enter a valid GDS email ID.",
};

// ============================================
// HOME & CHAT CONSTANTS
// ============================================
export const HOME = {
  ASSISTANT: "Assistant",
  SUPER_AGENT: "Super Agent",
  SUPER_AGENT_TOOLTIP:
    "This agent handles generic queries related to DID process.",
  ORDER_MODE: "Order Specific Mode",
  ORDER_MODE_TOOLTIP: "This agent addresses queries specific to this order.",
  WELCOME_ALT: "Welcome",
};

// Super Regions list for chat dropdown
export const SUPER_REGIONS = [
  { id: "general", name: "General" },
  { id: "africa", name: "Africa" },
  { id: "fso", name: "FSO" },
  // { id: "europe-west", name: "Europe West" },
  { id: "europe-west-netherlands", name: "Europe West - Netherlands" },
  { id: "europe-west-france", name: "Europe West - France" },
  { id: "mena", name: "MENA" },
];

export const CHAT = {
  ASK_PLACEHOLDER: "Ask me anything...",
  AXON_AI: "GDS.ai Axon",
  RECORD_AUDIO: "Record audio",
  SEND_MESSAGE: "Send message",
  SEE_ALL: "See All",
  SMART_SUGGESTIONS: "Smart Suggestions",
  AI_SUGGESTIONS: "AI Suggestions",
  MOST_USED: "Most used",
  KNOWLEDGE_PROMPTS: "Knowledge Prompts",
  COLLECTING_DATA: "Collecting Data...",
  FETCHING_FIELDS: "Fetching Fields..",
  LOADING_MESSAGE:
    "I'm searching for the information you requested. Please wait...",
  DISCLAIMER: "Use this tool in accordance with ",
  DISCLAIMER_LINK_TEXT1: "Assurance Generative AI Acceptable Use Policy",
  DISCLAIMER_LINK_URL1: "https://live.atlas.ey.com/#document/2818061",
  DISCLAIMER_SUFFIX: ", and ",
  DISCLAIMER_LINK_TEXT2: "Data Protection Guidelines for Generative AI",
  DISCLAIMER_LINK_URL2:
    "https://eygb.sharepoint.com/sites/GlobalDataProtectionDocumentation/Shared Documents/Forms/AllItems.aspx?id=%2fsites%2fGlobalDataProtectionDocumentation%2fShared+Documents%2fPolicies%2c+Guidance+and+Enablement+documents%2fData+Protection+Guidelines+-+AI+Systems+v3+(Final).pdf&parent=%2fsites%2fGlobalDataProtectionDocumentation%2fShared+Documents%2fPolicies%2c+Guidance+and+Enablement+documents&xsdata=MDV8MDJ8S2h1c2hib28uS2h1bGxhckBnZHMuZXkuY29tfDI5NDZjZTFiM2I4MDQxZGE2MmMwMDhkZWQwNWJiYjAzfDViOTczZjk5NzdkZjRiZWJiMjdkYWEwYzcwYjg0ODJjfDB8MHw2MzkxNzcyOTA3MzU2MzIyNjd8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=ZDFGNzhkaFc2b0FpQ1h0bzZCQnFJV3pFREVSNDVHbGc0ckxFQS8ya29mcz0%3d",
};

export const CHAT_ACTIONS = {
  ATTACH_FILES: "Attach Files",
  PLEASE_PROCEED: "Please proceed",
  ACTION_TAKEN: "Action Taken",
  FIX_REATTACH: "Fix & Re-attach File",
  NOTIFY_CONTRIBUTORS: "Notify Contributors",
  UPDATE_ORDER_INFO: "Update Order Info",
  UPDATE_MULTIPLE_FIELDS: "I want to update multiple fields at once",
  ACTIVITY_LOG: "Activity log of this Order",
  DISCLAIMER_TOOLTIP:
    "AI-generated outputs are intended to assist users and do not replace professional judgment, engagement team responsibilities, quality review procedures, or compliance with applicable EY policies and professional standards",
  DISCLAIMER1:
    "Users are required to review the accuracy and completeness of all AI output. ",
  DISCLAIMER:
    "Users are responsible for reviewing all AI-generated outputs and must not upload or enter Social Security Numbers or other sensitive personal data.",
};

export const CHAT_MESSAGES = {
  GENERIC_RESPONSE:
    "Something went wrong while processing your query. PLease try again...",
  COLLECTING_DATA: "Collecting Data...",
  LOADING: "Collecting data ...",
  PLAN_MY_DAY_INTRO:
    "✅ Here's your high-priority orders to begin with.\n\n👇 Select an order to proceed.",
  HIGH_PRIORITY_INTRO:
    "Here's your high priority orders list.\n\n👇 Select an order to proceed.",
  DATA_TRIAGE_INTRO:
    "Here's your orders list which are currently in Data Triage.\n\n👇 Select an order to proceed.",
  NEWLY_ALLOCATED_INTRO:
    "✅ Here's your newly allocated orders list.\n\n👇 Select an order to proceed.",
  AGEING_ORDERS_INTRO:
    "📊 Here's your ageing orders that require attention.\n\n👇 Select an order to proceed.",
  HIGH_ITERATION_ORDERS_INTRO:
    "🔄 Here's your high iteration orders list.\n\n👇 Select an order to proceed.",
  PENDING_REVIEW_INTRO:
    "⏳ Here's your orders pending at L1/L2 review.\n\n👇 Select an order to proceed.",
  MY_WEEKLY_ORDERS_INTRO:
    "📅 Here's your weekly orders summary.\n\n👇 Select an order to proceed.",
  AWAITING_RESPONSE_INTRO:
    "⏰ Here's your orders awaiting response from AT.\n\n👇 Select an order to proceed.",
  EMAIL_SUMMARY_ERROR:
    "I'm unable to provide a summary. Kindly review the email in Outlook for the required actions. Thank you.",
  NO_ORDERS_IN_CATEGORY: "No orders for you in this category...",
  ORDERS_NEARING_DUE_DATE_INTRO:
    "⏳ Here's your orders nearing Due date.\n\n👇 Select an order to proceed.",
  ALLOCATION_REVIEW_REQUEST_INTRO:
    "Here's the list of orders where review is requested.\n\n👇 Select an order to proceed.",
  ACTION_NEEDED_ORDERS_INTRO:
    "Here's the list of orders where action is needed from User.\n\n👇 Select an order to proceed.",
  CREATION_FAILURES_INTRO:
    "Here is the list of Orders where Order creation is pending.",
};

export const CHAT_SUGGESTIONS = {
  PLAN_MY_DAY: "Plan my day",
  HIGH_PRIORITY_ORDERS: "High Priority Orders",
  ORDERS_IN_DATA_TRIAGE: "Orders in Data Triage",
  NEWLY_ALLOCATED_ORDERS: "Newly Allocated Orders",
  PENDING_REVIEW: "Pending at L1/L2 review",
  AWAITING_AT_RESPONSE: "Awaiting response from AT",
  MANDATORY_FIELDS_JE: "What are mandatory fields in JE ?",
  MANDATORY_FIELDS: "What are mandatory fields in JE ?",
  RETAINED_EARNINGS: "What is Retained Earnings?",
  JOURNAL_ENTRY_GL: "What is Journal Entry / General Ledger?",
  WHAT_ARE_ACCOUNTS: "What are Accounts?",
  CHART_OF_ACCOUNTS: "What is Chart of Accounts or CoA?",
  BASIC_ACCOUNTING: "Basic Accounting in athematic manner",
  COMPRESSION_TIMING: "When is compression done?",
  REVIEWER_US: "Who is the reviewer for US- XXXX ?",
};

export const VALIDATION_MESSAGES = {
  MIN_LENGTH: "Value must be at least 2 characters long.",
  ALPHANUMERIC_ONLY: "Value should be alphanumeric only.",
  DATE_FORMAT: "Value should be in YYYY-MM-DD format.",
  FIELD_NOT_FOUND: "Field not found.",
};

// ============================================
// ORDERS CONSTANTS
// ============================================
export const ORDERS = {
  OPEN_ORDERS: "Open Orders",
  ACTION_NEEDED: "Action needed",
  SORT_BY: "Sort by",
  PRIORITY: "Priority",
  AGEING: "Ageing",
  DUE_DATE: "Due date",
  NO_ORDERS: "No orders available",
  NO_OPEN_ORDERS: "No open orders found",
  NO_ACTION_NEEDED: "No action needed orders found",
  FETCH_ERROR: "Failed to fetch orders. Please try again.",
};

export const ORDER_FILTERS = {
  OVERDUE: "Overdue",
  DUE_THIS_WEEK: "Due This Week",
  DATA_TRIAGE: "Data Triage",
  DATA_TRANSFORMATION: "Data Transformation",
  DATA_LOADING: "Data Loading",
};

// ============================================
// ORDER DETAILS CONSTANTS
// ============================================
export const ORDER_DETAILS = {
  STATUS_LABEL: "Status:",
  AGEING_LABEL: "Ageing in (By Status)",
  DUE_DATE_LABEL: "Due Date",
  SAVE: "Save",
  SHOW_ALL: "Show All",
  SHOW_LESS: "Show Less",
  NO_STATUS: "No status available",
  CURRENT_STATUS: "Current Axon Status",
  AXON_ID: "Axon ID:",
  EDIT: "Edit",
};

export const ORDER_TABS = {
  MAIN_DETAILS: "Main Details",
  MAIN: "Main",
  ADDITIONAL: "Additional Details",
  DATES: "Dates",
  CONTRIBUTORS: "Contributors",
  OTHER: "Other",
  CHECKLIST: "CheckList",
};

export const ORDER_STEPPER = {
  ORDER_CONFIRMATION: "Order Confirmation",
  DATA_TRIAGE: "Data Triage",
  DATA_PREPARATION: "Data Preparation",
  ANALYZER_LOADING: "Analyzer Loading",
  FINALIZATION: "Finalization",
  ARCHIVAL: "Archival",
};

export const ORDER_STATUSES = {
  ASSIGNED_REQUEST: "Assigned Request",
  DATA_RECEIVED: "Data Received",
  DATA_VALIDATION: "Data Validation",
  DATA_PREPARATION_COMPLETENESS: "Data Preparation and Completeness",
  COMPLETENESS_L1_REVIEW: "Completeness L1 Review",
  COMPLETENESS_L2_REVIEW: "Completeness L2 Review",
  COMPLETENESS_READY: "Completeness Ready for Delivery",
  AWAITING_ENGAGEMENT_TEAM:
    "Awaiting Engagement Team Completeness Confirmation",
  PREPARING_ANALYZER: "Preparing Analyzer & Memo",
  ANALYZER_L1_REVIEW: "Analyzer & Memo - L1 Review",
  ANALYZER_L2_REVIEW: "Analyzer & Memo - L2 Review",
  READY_FOR_DELIVERY: "Ready for Delivery",
  DELIVERED_ANALYZER: "Delivered Analyzer",
  PROJECT_COMPLETE: "Project Complete",
  CURRENT_AXON_STATUS: "Current Axon Status",
  FILE_VALIDATION: "File Validation",
  FILE_MAPPING: "File Mapping",
  DATA_PREP_COMPLETENESS: "Data Preparation & Completeness",
  AWAITING_INCOMPLETE_DATA: "Awaiting Engagement Team - Incomplete Data",
};

// ============================================
// FILE UPLOAD CONSTANTS
// ============================================
export const FILE_UPLOAD = {
  TRIAL_BALANCE: "Trial Balance",
  JOURNAL_ENTRY: "Journal Entry",
  CHART_OF_ACCOUNTS: "Chart of Accounts",
  OTHERS: "Others",
  CURRENT_YEAR: "Current Year (CY)",
  PREVIOUS_YEAR: "Previous Year (PY)",
  FINANCIAL_YEAR: "Financial Year",
  FILE_TYPE: "File Type",
  FILE_UPLOAD_TITLE: "File upload",
  UPLOAD_NEW_FILE: "Attach Files",
  SELECT_FILE_TYPE_FIRST: "Please select the file type first and then attach",
  CLICK_TO_UPLOAD: "Click to upload",
  DRAG_AND_DROP: "or drag and drop",
  SUPPORTED_FORMATS: "xlsx, xlsm, xls, txt, or csv",
  CANCEL: "Cancel",
  CONTINUE: "Continue",
  UPLOAD: "Upload",
  // Disclaimer modal
  IMPORTANT_DISCLAIMER: "Important Disclaimer",
  DISCLAIMER_TEXT_1:
    "EY Business Information including client data may be subject to additional confidentiality, regulatory, or access restrictions. Users are responsible for ensuring compliance with all applicable data protection, confidentiality, engagement, and regulatory requirements before uploading any information.",
  DISCLAIMER_TEXT_2:
    "Do not upload data relating to clients or entities in Germany, Switzerland, Austria, or KSA (Riyadh, Jeddah, and Al Khobar).",
  DISCLAIMER_TEXT_3: "By continuing, you confirm that :",
  DISCLAIMER_LIST: [
    "You have all required rights to upload and process the information.",
    "Do not upload or enter Social Security Numbers or other sensitive personal data",
    "The use of this tool is permitted for the relevant engagement and jurisdiction.",
  ],
  DISCLAIMER: "Use this tool in in accordance with ",
  DISCLAIMER_LINK_TEXT1: "Assurance Generative AI Acceptable Use Policy",
  DISCLAIMER_LINK_URL1: "https://live.atlas.ey.com/#document/2818061",
  DISCLAIMER_SUFFIX: ", and ",
  DISCLAIMER_LINK_TEXT2: "Data Protection Guidelines for Generative AI",
  DISCLAIMER_LINK_URL2:
    "https://eygb.sharepoint.com/sites/GlobalDataProtectionDocumentation/Shared Documents/Forms/AllItems.aspx?id=%2fsites%2fGlobalDataProtectionDocumentation%2fShared+Documents%2fPolicies%2c+Guidance+and+Enablement+documents%2fData+Protection+Guidelines+-+AI+Systems+v3+(Final).pdf&parent=%2fsites%2fGlobalDataProtectionDocumentation%2fShared+Documents%2fPolicies%2c+Guidance+and+Enablement+documents&xsdata=MDV8MDJ8S2h1c2hib28uS2h1bGxhckBnZHMuZXkuY29tfDI5NDZjZTFiM2I4MDQxZGE2MmMwMDhkZWQwNWJiYjAzfDViOTczZjk5NzdkZjRiZWJiMjdkYWEwYzcwYjg0ODJjfDB8MHw2MzkxNzcyOTA3MzU2MzIyNjd8VW5rbm93bnxUV0ZwYkdac2IzZDhleUpGYlhCMGVVMWhjR2tpT25SeWRXVXNJbFlpT2lJd0xqQXVNREF3TUNJc0lsQWlPaUpYYVc0ek1pSXNJa0ZPSWpvaVRXRnBiQ0lzSWxkVUlqb3lmUT09fDB8fHw%3d&sdata=ZDFGNzhkaFc2b0FpQ1h0bzZCQnFJV3pFREVSNDVHbGc0ckxFQS8ya29mcz0%3d",
  CONFIRM_AND_CONTINUE: "Confirm & Continue",
};

export const FILE_TABLE = {
  FILE_NAME: "File Name",
  FILE_TYPE: "File Type",
  STATUS: "Status",
  MODIFIED: "Modified",
  ACTIONS: "Actions",
  SEARCH_PLACEHOLDER: "Search ...",
  EDIT: "Edit",
  DELETE: "Delete",
};

export const FILE_STATUSES = {
  UPLOADED: "Uploaded",
  PROCESSING: "Processing",
  VALIDATED: "Validated",
  ALL_OK: "All ok",
};

export const FILE_CHECKS = {
  FILE_FORMAT_VALIDATION: "File Format Validation",
  COLUMN_HEADERS_CHECK: "Column Headers Check",
  DATA_TYPE_VALIDATION: "Data Type Validation",
  DUPLICATE_RECORDS: "Duplicate Records",
  MISSING_VALUES_CHECK: "Missing Values Check",
  FILE_CHECKS_TITLE: "File Checks",
  VALIDATION_PASSED: "File validation passed successfully",
  ISSUES_IDENTIFIED: "Issues identified. Please remove or upload correct file",
  ALL_FILES: "All files",
  INCOMPLETE_DATA: "Incomplete Data",
  REPLACE: "Replace",
  SHOW: "Show",
  DELETE: "Delete",
  LOAD_SAMPLE_REVIEW: "Load Sample & Review Mapping",
};

export const FILE_MAPPING = {
  MANDATORY_FIELDS: "Mandatory Fields",
  NON_MANDATORY_FIELDS: "Non-Mandatory Fields",
  MAPPED_FIELDS: "Mapped Fields",
  UNMAPPED_FIELDS: "Un Mapped Fields",
  FILE: "File",
  TAB_SHEET: "Tab/Sheet",
  DELIMITER: "Delimiter",
  HEADER_ROW: "Header Row",
  DATA_ROW: "Data Row",
  STANDARD_HEADER: "Standard Header",
  FIELDS_FROM_RAW: "Fields from Raw File",
  COMPUTATIONS: "Computations/Formula",
  FIELD_TYPE: "Field Type",
  SAMPLE_OUTPUT: "Sample Output",
  APPLY_TO_ALL_JE: "Apply to all JE Files",
  EXPORT_TO_EXCEL: "Export to Excel",
};

export const FILE_TYPE_OPTIONS = {
  JOURNAL_ENTRY_JE: "Journal Entry (JE)",
  TRIAL_BALANCE_TB: "Trial Balance (TB)",
  COE: "COE",
  DIMENSION_TABLE: "Dimension table",
  COA: "Chart of Accounts (CoA)",
  OTHER: "Other",
};

// ============================================
// UPLOAD PROGRESS CONSTANTS
// ============================================
export const UPLOAD_PROGRESS = {
  UPLOADING: "Uploading",
  PLEASE_WAIT: "Please wait while we upload your file.",
  COMPLETED: "completed",
  OPEN_THREAD: "Open thread",
};

// ============================================
// NOTIFICATIONS CONSTANTS
// ============================================
export const NOTIFICATIONS = {
  TITLE: "Notifications",
  FILTER_BY: "Filter by",
  CLOSE: "Close",
  NO_NOTIFICATIONS_ICON: "📭",
  NO_NOTIFICATIONS_MESSAGE: "You're all caught up!",
  MARK_ALL_READ: "Mark All Read",
  VIEW_ALL: "View All",
  DISMISS: "Dismiss",
  DISMISS_NOTIFICATION: "Dismiss notification",
  MARK_AS_READ: "Mark as read",
  ACTION_TAKEN: "Action Taken",
};

// ============================================
// COMMON UI CONSTANTS
// ============================================
export const COMMON_UI = {
  SEARCH: "Search",
  NO_ERROR: "No Error",
  GO_BACK: "Go back",
  CLOSE: "Close",
  EXPAND: "Expand",
  COLLAPSE: "Collapse",
};

export const PLACEHOLDERS = {
  ENTER_NUMBER: "Enter number",
  ENTER_AD_USER: "Enter user from Active Directory",
  SELECT: "Select",
  ASK_ME_ANYTHING: "Ask me anything...",
  PLEASE_WAIT: "Please wait for the response...",
};

export const ARIA_LABELS = {
  LOG_OUT: "Log out",
  NOTIFICATIONS: "Notifications",
  GO_BACK: "Go back",
  CLOSE: "Close",
  RECORD_AUDIO: "Record audio",
  SEND_MESSAGE: "Send message",
  DISMISS_NOTIFICATION: "Dismiss notification",
  MARK_AS_READ: "Mark as read",
  COLLAPSE: "Collapse",
  EXPAND: "Expand",
  REDUCE: "Reduce",
  STOP_PROCESS: "Stop process",
  UPLOAD_FILE: "Upload file",
};

// ============================================
// RECOMMENDED ACTIONS
// ============================================
export const RECOMMENDED_ACTIONS = {
  DATA_PREP_IN_PROGRESS: "Data Preparation and Completeness In Progress",
  PREPARING_ANALYZER_MEMO: "Preparing Analyzer and Memo",
  PROCEED_ANALYZER_CREATION: "Proceed with Analyzer Creation.",
  REFER_COA: "Refer to the attached COA.",
  SETUP_CALL: "setup call for further discussion",
  RECOMMENDED_ACTION: "Recommended Action",
  ACTION_TAKEN: "Action Taken",
  STATUS_UPDATED: "Status updated to Preparing Analyzer.",
  SUMMARIZING_EMAIL: "Summarizing email",
};

// ============================================
// ACTIVITY LOG CONSTANTS
// ============================================
export const ACTIVITY_LOG_TABLE_HEADERS = [
  "Activity Type",
  "Activity Details",
  "New Value",
  "Updated By",
  "Agent Type",
  // "Role",
  "Old Value",
  "Date & Time",
];

export const DEFAULT_ACTIVITY_LOGS = [
  {
    activityType: "Status Update",
    activityDetails: "Order Status",
    newValue: "Data Received",
    updatedBy: "GDS.ai Axon",
    role: "···",
  },
  {
    activityType: "File Upload",
    activityDetails: "Journal Entry File",
    newValue: "JE_P1_2025.xlsx",
    updatedBy: "John Doe",
    role: "Preparer",
  },
  {
    activityType: "File Upload",
    activityDetails: "Trial Balance Beginning",
    newValue: "TB_beg_2025.xlsx",
    updatedBy: "John Doe",
    role: "Preparer",
  },
  {
    activityType: "File Upload",
    activityDetails: "Trial Balance Ending",
    newValue: "TB_end-2025.xlsx",
    updatedBy: "John Doe",
    role: "Preparer",
  },
  {
    activityType: "Status Update",
    activityDetails: "Order Status",
    newValue: "Data Received Incomplete",
    updatedBy: "John Doe",
    role: "Preparer",
  },
  {
    activityType: "File Replace",
    activityDetails: "Journal Entry File",
    newValue: "JE_P1_2025.xlsx",
    updatedBy: "John Doe",
    role: "Preparer",
  },
  {
    activityType: "Field Update",
    activityDetails: "Due Date",
    newValue: "25/12/2025",
    updatedBy: "William R",
    role: "Reviewer",
  },
];
